<template>
	<div class="flow-widget-actions-wrapper">
		<div
			v-for="action in actions"
			:key="action.name"
			class="flow-widget-action"
			@click="handleActionClick(action)"
		>
			<span class="action-name">{{ action.name }}</span>
			<Icon
				:name="action.icon"
				class="cursor-pointer"
				state="dark"
				:effects="false"
				type="filled"
				size="small"
			/>
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../../Icon/Icon";

export default defineComponent({
	name: "WidgetActions",
	components: {
		Icon
	},
	props: {
		/**
		 * [
		 * 	{
		 * 		name:String,
		 * 		icon:String
		 * 	}
		 * ]
		 *
		 */
		actions: {
			type: Array,
			default: () => [
				{
					name: "Edit",
					icon: "settings"
				},
				{
					name: "Move",
					icon: "scissor"
				}
			]
		}
	},
	methods: {
		handleActionClick(action) {
			/**
			 * on action icon click
			 *
			 * @event actionclick
			 */
			this.$emit("actionclick", action);
		}
	}
});
</script>
<style lang="scss">
div.flow-widget-actions-wrapper {
	grid-area: 1 / 2 / end / end;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	flex-direction: column;
	position: absolute;
	top: 0px;
	right: 0px;
	visibility: hidden;
	> div.flow-widget-action {
		margin: 4px 4px 0px 4px;
		z-index: 2;
		height: 32px;
		width: 32px;
		border-radius: 16px;
		display: inline-flex;
		align-items: center;
		justify-content: flex-end;
		background-color: var(--dashboard-background);
		padding: 8px;
		overflow: hidden;

		> span.action-name {
			font-size: 10px;
			line-height: 10px;
			color: transparent;
			cursor: pointer;

			transition: max-width 0.3s linear, margin-right 0.3s linear;
			max-width: 0;
			text-transform: uppercase;
		}
		> div.icon-container {
			display: none;
		}

		&:hover {
			width: auto;
			> span.action-name {
				margin-right: 8px;
				margin-left: 8px;
				max-width: 10vw;
				color: var(--dashboard-font-dark);
			}
		}
	}
}

div.vue-grid-item:hover,
div.position-relative:hover {
	> div.flow-widget-actions-wrapper {
		visibility: visible;

		> div.flow-widget-action {
			> div.icon-container {
				display: inline-flex;
			}
		}
	}
}
</style>
